<template>
    <div class="starMgt spackage padding-20 bgc box-shadow" v-loading="loading">

        <section class="startMgt-header">

            <el-button type="primary" align="left" @click="createStarMgt">新建星球</el-button>

            <div align="right" style="float:right">
                <el-select v-model="selectValue" placeholder="全部状态">
                    <el-option
                        v-for="item in status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>

                <el-input placeholder="输入星球名称" v-model="nameInput" style="width: 240px"></el-input>
                <el-button type="primary" @click="search()" plain>搜索</el-button>
            </div>
        </section>
        <!-- end 顶部菜单栏 -->

        <section>
            <el-table :data="tableData">
                <el-table-column label="星球名称" align="left" width="330">
                    <template slot-scope="scope">
                        <div class="table-title">
                            <img :src="scope.row.starlogourl" alt="headerimg">
                            <div class="table-txt">
                               <p class="sub-title" style="margin-bottom: 8px">{{scope.row.starname}}</p>

                                <p style="height: 20px; font-size: 13px; color: #F56C6C" v-if="scope.row.feetype == 1 || scope.row.feetype == 2">免费</p>
                                <p style="height: 20px;" v-else>
                                    <span style="font-size: 13px; color: #F56C6C ">{{scope.row.joinfactmoney}}元</span>
                                    <span v-if="scope.row.joinfactmoney !== scope.row.joinmoney && scope.row.joinmoney !== '0.00'" style="font-size: 12px; margin-left: 5px; color: #F56C6C; text-decoration: line-through">{{scope.row.joinmoney}}元</span>
                                </p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center" width="180"></el-table-column>
                <el-table-column prop="feetypename" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="membercount" label="成员数" align="center"></el-table-column>
                <el-table-column prop="subjectcount" label="帖子数" align="center"></el-table-column>
                <el-table-column prop="filecount" label="资料数" align="center"></el-table-column>
                <el-table-column prop="topcount" label="精华数" align="center"></el-table-column>
                <el-table-column label="状态" align="center">

                    <template slot-scope="scope">
                        <div class="table-status">
                            <p class="status-1" v-if="scope.row.status == 1"><span></span>正常</p>
                            <p class="status-2" v-if="scope.row.status == 100"><span>·</span>解散</p>
                            <!--<p class="status-3" v-if="scope.row.status == 11"><span>·</span>隐藏</p>-->
                        </div>
                    </template>

                </el-table-column>
                <el-table-column label="操作" align="right" width="150">

                    <template slot-scope="scope">
                        <div class="table-position">
                            <el-button @click="share(scope.row.shareurl, scope.row.starname)">分享</el-button>
                            <span>|</span>
                            <el-button @click="newgoto('PlanetCommunityIndex',scope.row.innerid)">查看详情</el-button>
                        </div>
                    </template>


                </el-table-column>
            </el-table>
        </section>
        <!-- end 表单 -->

        <section>
            <el-pagination background layout="prev,pager,next" :total="rowCount"  @current-change="fPage()" :current-page.sync="currentPage" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- end 分页 -->

        <el-dialog title="分享" :visible.sync="dialogVisible" class="share-popu" width="305px">
            <div class="content">
                <!-- <p class="title">华扬资本董秘培训专场社群团购优惠</p> -->
                <div class="img">
                    <img :src="shareList.imgurl" alt="qrcode">
                </div>
                <p class="down" @click="download(shareList.imgurl, shareList.name)" style="cursor: pointer">下载二维码</p>
                <div class="btn-operate">
                    <el-input v-model="shareList.url" class="condition" disabled></el-input>
                    <el-button  type="primary" size="mini" v-clipboard:copy="shareList.url" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
        </el-dialog>
        <!--  分享  -->
    </div>
</template>

<script>
import {checkModule} from '@/api/api'
import {findStarList,findStarfile,updateStarByStatus,updateStarSubjectByStatus,updateStarfileByStatus,updateStarnotesByStatus,uploadMeberRole} from '@/api/starMgtApi' // 引入星球管理 api 资源文件
import {getCookie, downloadImage, urlToQRCode} from '@/common/js/tools' // 引入 tools 库
// import Loading from 'base/loading/loading' // 引入 loading 组件
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery' // 引入 jquery 组件

export default {
    name: 'starMgt',
    data(){
        return {
            shareList: {
                name: '',
                url: '',
                imgurl: ''
            },
            dialogVisible: false,
            loading: false, // 加载
            token: getCookie('token'), // token
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
            selectValue: '', // 选择条件
            nameInput: '', // 输入条件
            currentPage: 1, // 当前页面
            rowCount: 0, // 数据条数
            page: 1, // 页数
            apiData: {}, // 查询/分页 api 数据
            tableData: [], // 星球管理表单数据
            status: [ //{value: 11, label: '隐藏'}
                {
                    value: '',
                    label: '全部状态'
                },
                {
                    value: 1,
                    label: '正常'
                },
                {
                    value: 100,
                    label: '解散'
                }
            ]

        }
    },
    mounted() {
        // this.loading = true;
        this.setLoading(true)
        // 星球管理列表接口 参数
        this.apiData = {
            LoginToken: this.token,
            shopID: this.shopID,
            page: 1,
            pageSize: 10
        }
        this.starMgtApi()
    },
    methods: {
        createStarMgt() {
            var params = {
                moduleid: 'A03'
            }
            checkModule({
                data: Object.assign({}, params),
                success: data => {
                    this.$router.push({ name: 'CreateStarMgt', query:{'type': 'add'}})
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                }
            })
        },
        download(imgsrc, name) { // 下载图片地址和图片名
                downloadImage(imgsrc, name)
        },
        onCopy(e){ // 复制成功
                this.$message({
                    message: '复制成功',
                    type: 'success'
                })
            },
        onError(e) {  // 复制失败
                this.$message({
                    message: '复制失败',
                    type: 'error'
                })
        },
        share(url,name) {
            this.dialogVisible = true
            this.shareList.name = name
            this.shareList.url = url
             this.shareList.imgurl = urlToQRCode(url)
        },
        // 星球管理查询、分页通用接口调用
        starMgtApi() {
            findStarList({
                data:this.apiData,
                success:data => {
                    // this.loading = false
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount
                },
                error:data => {
                    // this.loading = false
                    this.setLoading(false)
                    // console.log(data)
                }
            });
        },
        newgoto(href,innerid) {
            let hrefs = this.$router.resolve({name:href, query:{'innerid': innerid}})
            console.log(hrefs)
            window.open(hrefs.href,'_blank')
            // this.$router.push({name:href, query:{'innerid': innerid}})
        },
        goto(href,innerid){
            this.$router.push({name:href, query:{'innerid': innerid}})
        },
        search(){
            // 搜索
            // this.loading = true
            this.setLoading(true)
            // 星球管理列表查询
            this.apiData = {
                LoginToken: this.token,
                shopID: this.shopID,
                page: 1,
                pageSize: 10,
                starname: this.nameInput,
                status: this.selectValue
            }
            this.starMgtApi()
        },
        fPage(){
            // 分页
            // 开启加载
            this.setLoading(true);
            // this.loading = true
            let clickPage = $(".el-pagination .active").html()
            this.apiData.page = clickPage
            this.starMgtApi()
        },
        // 修改星球状态
        updateStarByStatus(status, innerid){
            let txt;// 文案
            switch(status) {
                case 1:
                    txt = '您确定公开该星球吗？'
                    break
                case 11:
                    txt = '您确定隐藏该星球吗？'
                    break
                case 100:
                    txt = '您确定解散该星球吗？'
                    break
            }
            this.$confirm(txt, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    LoginToken: this.token,
                    innerid: innerid,
                    status: status
                }
                updateStarByStatus({
                    data: data,
                    success: data => {
                        if (data.code === '000') {
                            console.log(data)
                            // 修改页面状态
                            updateStarMgtStatus(this, innerid, status)
                        }
                    },
                    error: data => {
                        console.log(data)
                    }
                })
            }).catch(() => {})
            // 修改页面状态
            function updateStarMgtStatus($this, innerid, status) {
                for (let i = 0; i < $this.tableData.length; i++) {
                    if ($this.tableData[i].innerid === innerid) {
                        $this.tableData[i].status = status
                        continue
                    }
                }
            }
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/starmgt";
    .el-message-box__content {
        padding: 30px 50px!important;
        text-align: center!important;
        color: #F56C6C!important;
    }
    .el-message-box__btns {
        text-align: center!important;
        .el-button {
            margin-bottom: 30px!important;
        }
    }
    .starMgt {
        .el-table {
            .sub-title {
                display: -webkit-box;
                max-height: 40px;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;
                -ms-box-orient: vertical;
                box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

        }
        .startMgt-header {
            height: 40px;
            margin-bottom: 40px;
            .el-input__icon {
                height: 36px ;
            }
            .el-select,
            .el-select>.el-input,
            .el-button {
                height: 32px;
            }
            .el-select {
                width: 116px;
            }
            .el-select,
            .el-input {
                margin-right: 20px;
            }
        }

        .table-title {
            img {
                width: 106px;
                height: 60px;
            }

            .table-txt {
                display: block;
                width: calc(100% - 126px);
                height: 70px;
                p {
                    width: 100%;
                    height: 40px;
                }
            }

        }
        .table-position {
            .el-dropdown-link {
                a {
                    color: #303133;
                }
            }
        }
        .share-popu {
            .content {
                text-align: center;
                .title {
                    margin-top: 15px;
                    font-size: 14px;
                    color: #303133;
                }
                .img {
                    display: block;
                    margin: auto;
                    margin-top: 15px;
                    width:134px;
                    height:134px;
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        background: #ccc;
                    }
                }
                .down {
                    margin-top: 15px;
                    font-size: 14px;
                    color: #409EFF;
                }
                .btn-operate {
                    display: flex;
                    flex-wrap: nowrap;
                    -ms-flex-wrap: nowrap;
                    margin-top: 30px;
                    width: 264px;

                    .el-input input {
                        width: 210px;
                        font-size: 14px;
                        color: #c0c4cc
                    }
                    .el-button {
                        min-width: 54px;
                    }
                }
            }

        }
    }
</style>
